import * as XLSX from 'xlsx';

/**
 * Converts a CSV File to an XLSX File in the browser.
 *
 * AWS WAF managed rules inspect plain-text multipart bodies and can match on
 * CSV content (special characters, non-ASCII text, etc.).  XLSX is a ZIP
 * archive — WAF cannot inspect compressed binary, so conversion eliminates
 * the false-positive blocks without any WAF rule changes.
 *
 * The backend (`BulkUploadFiles`) accepts both formats; converting client-side
 * is transparent to the processing logic.
 */
export async function convertCsvToXlsx(csvFile: File): Promise<File> {
  const text = await csvFile.text();
  const workbook = XLSX.read(text, { type: 'string' });
  const xlsxBuffer = XLSX.write(workbook, { type: 'array', bookType: 'xlsx' });
  const xlsxBlob = new Blob([xlsxBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const xlsxName = csvFile.name.replace(/\.csv$/i, '.xlsx');
  return new File([xlsxBlob], xlsxName, { type: xlsxBlob.type });
}
